import ujs from "@rails/ujs"

class @App.Ui.Modals
  constructor: ->
    @bindElements()
    @openActivity()

  isSignedIn: ->
    currentUser = $('meta[name="current-user"]')
    currentUser and
      currentUser.attr('content') and
      currentUser.attr('content').length

  isSignedInTemp: ->
    tempUser = $('meta[name="temp-user"]')
    tempUser and tempUser.attr('content') and tempUser.attr('content').length

  openLogin: (e, option) =>
    if $('#bodyWrapper').data('allowtemp')
      @openLoginTemp(e, option)
    else
      if not @isSignedIn()
        e.preventDefault()
        $(e.currentTarget).parents('.selected').removeClass('selected')
        $(e.currentTarget).blur()
        $('#modalLogin .header').hide()
        header = $("#modalLogin .header." + option)
        if header.length
          header.show()
        else
          $('#modalLogin .header.default').show()
        if option == 'club'
          loginLink = $('#loginLink')[0].href
          $('#loginLink')[0].href = loginLink + '?student_talks=true'
          registerLink = $('#registerLink')[0].href
          $('#registerLink')[0].href = registerLink + '?student_talks=true'

        BetterModals.showModal $("#modalLogin")

  openLoginTemp: (e, option) =>
    if not @isSignedIn() and not @isSignedInTemp()
      e.preventDefault()
      $(e.currentTarget).parents('.selected').removeClass('selected')
      $(e.currentTarget).blur()

      BetterModals.showModal $("#modalLoginTemp")

  openReLoginTemp: (e, option) =>
    e.preventDefault()
    BetterModals.showModal $("#modalLoginTemp")

  openActivity: =>
    if $("#modalPublished").length > 0
      BetterModals.showModal $("#modalPublished")

  openFlag: (e) =>
    e.preventDefault()
    $(e.currentTarget).blur()
    App.uiModal.close()
    App.uiModal.open $("#modalFlag")

  bindElements: =>
    if !$(".edit_lesson").length
      $(document).on "click.loginModal", ".customize-this-lesson,
                                          .lessonsShowView #bodyWrapper input,
                                          .lessonsShowView button.send-answer,
                                          .lessonsShowView #bodyWrapper input,
                                          .lessonsShowView button.send-answer,
                                          .user-only", (e) =>
        @openLogin(e)

      $(document).on "focus.loginModal keyup.loginModals", "textarea.thinkfield", (e) =>
        @openLogin(e)

      $(document).on "click.loginModals", ".startDiscussion.public, .join.public,
                                           .login-required > div, .login-required > a", (e) =>
        @openLogin(e, "discussion")

      $(document).on "click.loginModals", ".club-form label", (e) =>
        if not @isSignedIn()
          e.preventDefault()

      $(document).on "click.loginModals", ".user-only-club,
                                           [data-form='student_talks'] :input,
                                           [data-login-popup-application='true']", (e) =>
        @openLogin(e, "club")

      $(document).on "click.loginModals", "[data-login-popup-leader='true']", (e) =>
        @openLogin(e, "leader")

      $(document).on "click.loginModals", ".new-temp-login", (e) =>
        @openReLoginTemp(e)

    $(document).on "change", "input[name=lesson\\[allow_temp_user\\]]", (e) =>
      ujs.fire($('form.edit_lesson').get(0), 'submit')

    $(document).on "click", ".enable-share button", (e) ->
      # hide student options
      $('.access-options').hide()
      $('.edit-notes').hide()
      $('.enable-share').hide()
      # show sharing form
      $('#share-tools').show()

    $(document).on "click.activityModal", "#modalPublished .lesson-href", ->
      @bindZClip()

    $(document).on "click", ".uiModalCloseExtra, .close-modal", (e) ->
      App.uiModal.close()
      false

$ ->
  new App.Ui.Modals()
